const magicKestrelSelector = '[onerror="invokePreload.onScriptError(this)"][onload="invokePreload.onScriptLoad(this)"]';
function toSelector(type) {
  return `link[rel="${type}"]${magicKestrelSelector}`;
}
const preloadTypeToRel = {
  /**
 *
 */
  default: "preload",
  /**
 *
 *
 */
  module: "modulepreload",
  /**
 *
 *
 */
  nomodule: "nomodulepreload",
  /**
 *
 *
 */
  dynamic: "dynamicpreload",
  /**
 *
 */
  systemjs: "systemjspreload"
};
const preloadTypeToSelector = Object.fromEntries(Object.entries(preloadTypeToRel).map(e => [e[0], toSelector(e[1])]));

window.invokePreload || (window.invokePreload = {});
const {
  invokePreload
} = window;

function getPreloadsFromMutationByType(mutations, type) {
  const res = [];
  mutations.forEach(m => {
    [].forEach.call(m.addedNodes, n => {
      if (n.nodeName === "LINK" && n.getAttribute("rel") === type) {
        res.push(n);
      }
    });
  });
  return res;
}
function getPreloadsBySelector(selector, element = document) {
  const preloads = element.querySelectorAll(selector);
  const uniquePreloads = [];
  const seenUrls = [];
  for (let i = 0, len = preloads.length; i < len; i += 1) {
    const preload = preloads[i];
    if (seenUrls.indexOf(preload.href) === -1) {
      seenUrls.push(preload.href);
      uniquePreloads.push(preload);
    }
  }
  return uniquePreloads;
}

function processScript(link, isAsync, resolve) {
  const scriptType = invokePreload.getLifeCycleData(link, "data-script");
  const rel = link.getAttribute("rel");
  const script = document.createElement("script");
  script.async = isAsync;
  script.onload = resolve;
  script.onerror = resolve;
  if (!scriptType || scriptType === "nomodule") {
    script.setAttribute("src", link.href);
  }
  if (scriptType === "module" || rel === preloadTypeToRel.module) {
    script.setAttribute("type", "module");
    script.setAttribute("src", link.href);
  }
  if (scriptType === "systemjs") {
    script.text = `System.import("${link.href}");`;
  }
  if (link.integrity) {
    script.integrity = link.integrity;
  }
  if (link.hasAttribute("crossorigin")) {
    script.setAttribute("crossorigin", link.getAttribute("crossorigin"));
  }
  if (link.insertAdjacentElement) {
    link.insertAdjacentElement("afterend", script);
  } else {
    link.parentNode.appendChild(script);
  }
  return script;
}

function sendCustomLog(errorUrls, details) {
  if (errorUrls.length > 0 && !!window.AS && !!window.AS.RUM && typeof window.AS.RUM.sendCustomRequest === "function") {
    const {
      __OTTO_BROWSER_UNSTABLE_UA_DATA: ua
    } = window;
    const payload = {
      ...(details && {
        details
      }),
      urls: errorUrls,
      ua: JSON.stringify(ua)
    };
    window.AS.RUM.sendCustomRequest("preloadError", payload);
  }
}

function getToggle(toggle) {
  return window.o_global?.toggles?.[toggle] || false;
}
const ASSETS_PRELOAD_ERROR_CATCH_DETAILS = "ASSETS_PRELOAD_ERROR_CATCH_DETAILS";

function reportFailed(data) {
  const errorUrls = data.filter(el => el && !!el.isError && !!el.href && /https:\/\/[\w.]*otto.de\/\S+/.test(el.href) && !!el.preloadState).map(el => el.href).filter(Boolean);
  const fetchErrorDetails = url => Promise.race([new Promise(resolve => {
    window.fetch(url).then(response => response.ok ||
    /*                                                    */
    response.status === 499 && !getToggle(ASSETS_PRELOAD_ERROR_CATCH_DETAILS) ? resolve(void 0) : resolve({
      url,
      detail: response.status.toString()
    })).catch(e => getToggle(ASSETS_PRELOAD_ERROR_CATCH_DETAILS) ? resolve({
      url,
      detail: e.toString()
    }) : resolve(void 0));
  }), new Promise(resolve => {
    setTimeout(() => getToggle(ASSETS_PRELOAD_ERROR_CATCH_DETAILS) ? resolve({
      url,
      detail: "timeout"
    }) : resolve(void 0), 3e3);
  })]);
  return Promise.all(errorUrls.map(fetchErrorDetails)).then(results => {
    const [urls, details] = results.filter(Boolean).reduce((res, curr) => {
      res[0].push(curr.url);
      res[1].push(curr.detail);
      return res;
    }, [[], []]);
    sendCustomLog(urls.join(), details.join());
  }).catch(e => {});
}
function processLink(element, isAsync, resolve, tryCount = 1) {
  const preloadState = invokePreload.getLifeCycleData(element, "data-preloaded");
  if (preloadState === "noinvoke") {
    resolve({
      isError: false,
      href: element.href,
      preloadState
    });
    return;
  }
  if (preloadState === "success") {
    processScript(element, isAsync, resolve);
  } else if (preloadState === "try-with-error") {
    processScript(element, isAsync, () => resolve({
      isError: true,
      href: element.href,
      preloadState
    }));
  } else if (preloadState === "error") {
    resolve({
      isError: true,
      href: element.href,
      preloadState
    });
  } else if (tryCount <= 100) {
    setTimeout(() => {
      processLink(element, isAsync, resolve, tryCount + 1);
    }, tryCount * 50);
  } else {
    resolve({
      isError: true,
      href: element.href,
      preloadState: "error"
    });
  }
}
function invokePreloadedScripts(preloads, setAsync) {
  return window.Promise.all(preloads.map(p => new window.Promise(resolve => {
    processLink(p, setAsync, resolve);
  })));
}

function reportPreload(data) {
  reportFailed(data);
  document.dispatchEvent(new CustomEvent("AllScriptsExecuted"));
  document.dispatchEvent(new CustomEvent("AllPreloadScriptsLoaded"));
  window.o_global?.eventQBus?.emitRetain("assets.preload.allScriptsLoaded");
}
function getInvocableElements(parent) {
  const support = invokePreload.browserSupport;
  let selector = `${preloadTypeToSelector.default}[as='script']`;
  if (support.modulepreload) {
    selector += `, ${preloadTypeToSelector.module}[as='script']`;
  }
  const preloads = getPreloadsBySelector(selector, parent);
  return preloads;
}
function invokePreloads() {
  const preloads = getInvocableElements();
  const criticals = [];
  const noncriticals = [];
  preloads.forEach(p => {
    if (p.hasAttribute("data-critical") || p.hasAttribute("critical")) {
      criticals.push(p);
    } else {
      noncriticals.push(p);
    }
  });
  const setNonCriticalAsync = criticals.length === 0;
  return (
    /*                                      */
    invokePreloadedScripts(criticals, false).then(() => invokePreloadedScripts(noncriticals, setNonCriticalAsync)).then(reportPreload)
  );
}
function processPreloadsOnElement(parent) {
  invokePreload.processByQuery(parent);
  const preloads = getInvocableElements(parent);
  return invokePreloadedScripts(preloads, true).then(reportFailed);
}

const typeMap = {
  [preloadTypeToRel.module]: "module",
  [preloadTypeToRel.dynamic]: "module",
  [preloadTypeToRel.systemjs]: "systemjs",
  [preloadTypeToRel.nomodule]: "nomodule",
  [preloadTypeToRel.default]: "nomodule"
};
function adjustPreloadLink(element) {
  const linkRel = element.getAttribute("rel");
  const type = typeMap[linkRel];
  const newRel = invokePreload.browserSupport.modulepreload && type === "module" ? preloadTypeToRel.module : preloadTypeToRel.default;
  invokePreload.setLifecycleData(element, "data-script", type);
  element.setAttribute("rel", newRel);
}
const processed = [];
function processPreloadLink(element) {
  if (processed.indexOf(element.href) !== -1) {
    return;
  }
  if (invokePreload.preloadElement) {
    invokePreload.preloadElement(element);
  }
  processed.push(element.href);
}

const processors = [
/*                              */
{
  check: s => s.dynamicimport,
  selectors: [preloadTypeToSelector.dynamic, preloadTypeToSelector.module],
  types: [preloadTypeToRel.dynamic, preloadTypeToRel.module]
},
/*                           */
{
  check: s => s.typemodule && !s.dynamicimport,
  selectors: [preloadTypeToSelector.systemjs, preloadTypeToSelector.module],
  types: [preloadTypeToRel.systemjs, preloadTypeToRel.module]
},
/*                                     */
{
  check: s => !s.typemodule,
  selectors: [preloadTypeToSelector.nomodule, preloadTypeToSelector.systemjs],
  types: [preloadTypeToRel.systemjs, preloadTypeToRel.nomodule]
}];
function processByQuery(parent) {
  processors.filter(p => p.check(invokePreload.browserSupport)).forEach(({
    selectors: sels
  }) => sels.forEach(s => getPreloadsBySelector(s, parent).forEach(adjustPreloadLink)));
  getPreloadsBySelector(preloadTypeToSelector.default, parent).forEach(processPreloadLink);
}
function processLinksByMutation(mutations) {
  processors.filter(p => p.check(invokePreload.browserSupport)).forEach(({
    types: tps
  }) => tps.forEach(t => getPreloadsFromMutationByType(mutations, t).forEach(adjustPreloadLink)));
  getPreloadsFromMutationByType(mutations, preloadTypeToRel.default).forEach(processPreloadLink);
}
function processByMutation() {
  const observer = new window.MutationObserver(processLinksByMutation);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener("DOMContentLoaded", () => {
    observer?.disconnect();
  });
}

function installObserver() {
  processByQuery();
  processByMutation();
}

invokePreload.processByQuery = processByQuery;
if (invokePreload.browserSupport.detectionComplete) {
  installObserver();
} else {
  document.addEventListener("PreloadFeatureDetectionComplete", installObserver);
}
invokePreload.processPreloadsOnElement = processPreloadsOnElement;
window.preload_polyfill_invoke = processPreloadsOnElement;
document.addEventListener("DOMContentLoaded", () => {
  processByQuery();
  invokePreloads();
});
/*                                 */
